import isEmpty from "./helpers/isEmpty";
import NewsModel from "./models/NewsModel";
import PagedResponse from "./models/PagedResponse";
import newsFetch from "./api/newsFetch";

/**
 * Init news container
 *
 * @param {string} htmlContainerId
 * @param {string} htmlNewsListId
 * @param {string} htmlFilterButtonId
 * @param {string} htmlCategorySelectId
 * @returns
 */
const initNewsContainer = (
  htmlContainerId,
  htmlNewsListId,
  htmlFilterButtonId,
  htmlCategorySelectId
) => {
  const container = document.getElementById(htmlContainerId);
  if (!container) return;

  fetchData(container, htmlNewsListId);

  $(document).ready(() => {
    $("#loadMorePress").on("click", function (e) {
      e.preventDefault();

      if (window.currentPageNumber < window.lastPageNumber) {
        getDataPress(window.currentPageNumber + 1, PerPageQuery);
      }

      if (window.currentPageNumber == window.lastPageNumber) {
        $("#loadMorePress").text("No more content").addClass("noContent");
      }
    });

    $(`#${htmlFilterButtonId}`).on("click", (e) => {
      e.preventDefault();
      const categorySelect = document.getElementById(htmlCategorySelectId);
      if (categorySelect) {
        container.dataset.page = 1;
        container.dataset.categoryId = categorySelect.value;
        fetchData(container, htmlNewsListId);
      }
    });
  });
};

/**
 * Load news content.
 *
 * @param {HTMLElement} container - container containing html data variables
 * @param {string} htmlNewsListId - id of html container containing news cards
 */
const fetchData = async (container, htmlNewsListId) => {
  const {
    protocol,
    host,
    apiSuffix,
    folderId,
    page,
    perPage,
    categoryId,
    listingPageId,
  } = container.dataset;

  const response = await newsFetch(
    protocol,
    host,
    apiSuffix,
    folderId,
    categoryId,
    page,
    perPage,
    listingPageId
  );

  if (response.success) {
    const data = !isEmpty(response.data) ? response.data : new PagedResponse();
    printDataPress(container, data, htmlNewsListId);
  } else {
    printDataPress(container, new PagedResponse(), htmlNewsListId);
  }
};

/**
 *
 * @param {HTMLElement} container - container containing html data variables
 * @param {PagedResponse} pagedResponse - class model of paged response
 * @param {string} htmlNewsListId - id of html container containing news cards
 */
function printDataPress(container, pagedResponse, htmlNewsListId) {
  const newsListContainer = document.getElementById(htmlNewsListId);
  if (!newsListContainer) return;

  if (container.dataset.perRow) {
    newsListContainer.style.setProperty("--perRow", container.dataset.perRow);
  }

  let html = "";
  if (pagedResponse && pagedResponse.results && pagedResponse.results.length) {
    pagedResponse.results.forEach((element, index) => {
      if (element instanceof NewsModel) {
        html += element.generateNewsCard();
      }
    });
  } else {
    html = pagedResponse.generateNoResults(container.dataset.perRow, 5);
  }
  newsListContainer.innerHTML = html;

  const pagination = pagedResponse.createPagination(
    newsListContainer.nextElementSibling,
    container,
    () => fetchData(container, htmlNewsListId)
  );
  newsListContainer.insertAdjacentElement("afterend", pagination);
}

initNewsContainer(
  "newsContainer",
  "newsGeneralList",
  "newsFilterButton",
  "newsCategorySelect"
);

export default initNewsContainer;
